import React from 'react';

import styled from 'styled-components';

import { ISection } from '@rbi-ctg/menu';
import { primitive } from 'styles/constants/primitives';
import { hasPropertyLocale } from 'utils/has-property-locale';

const Header = styled.div`
  margin-top: ${primitive.$spacing6};

  ${Styles.desktop`
    margin-top: 4rem;
  `}
`;

const Content = styled.div`
  margin: 0 auto;
  text-align: center;
`;

const SectionName = styled.h1`
  margin: 0;
`;

const VisuallyHiddenH1 = styled.h1`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  white-space: nowrap;
  word-wrap: normal;
`;

type Props = {
  section: ISection;
};

export default function MainMenuSectionHeader(props: Props) {
  const hasHeaderSuperText = hasPropertyLocale(props.section, 'headerSuperText');
  const sectionName = props.section.name?.locale;

  return (
    <Header>
      <Content>
        {hasHeaderSuperText ? (
          <SectionName>{props.section.headerSuperText?.locale}</SectionName>
        ) : sectionName ? (
          <VisuallyHiddenH1>{sectionName}</VisuallyHiddenH1>
        ) : null}
      </Content>
    </Header>
  );
}
